import ClasImpl from '@/serviceImpl/ClasImpl';
import {Profile} from '@/domain/entities/Profile';
import {getCredentialsOrThrow} from '@/domain/useCases/getCredentialsOrThrow';

const getProfileUseCase = async (): Promise<Profile | undefined> => {
  const accessToken = getCredentialsOrThrow();

  try {
    return await ClasImpl.profile(accessToken);
  } catch (error) {
    console.error('Error fetching profile', error);
    throw error;
  }

};

export default getProfileUseCase;